import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

  const routes = [
  {
    path: '*',
    redirect: '/authUrl'
  },
  {
    path: '/authUrl',
    name: 'AuthUrl',
    component: resolve => require(['../views/AuthUrl.vue'], resolve),
    meta: {
      title: '登录'
    }
  },
  {
    path: '/shareUrl',
    name: 'ShareUrl',
    component: resolve => require(['../views/ShareUrl.vue'], resolve),
    meta: {
      title: '分享'
    }
  }
]

const router = new VueRouter({
  routes
})

export default router
